import {
  Box,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const ETLProcessListskeleton = () => {
  const rows = Array.from({ length: 10 });

  return (
    <Box px={1} pt={2} pb={3}>
      {/* Title */}
      <Box mb={2}>
        <Skeleton width={260} height={32} />
        <Skeleton width={380} height={20} />
      </Box>

      {/* Top Controls */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Stack direction="row" spacing={4} alignItems="center">
          <Skeleton variant="rectangular" width={260} height={40} />
          <Skeleton width={90} height={24} />
          <Skeleton width={110} height={24} />
        </Stack>

        <Skeleton variant="rectangular" width={210} height={40} />
      </Stack>

      {/* Table */}
      <Paper variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              {["ID", "Process Name", "Last Run", "Status", "Run Process"].map(
                (_, index) => (
                  <TableCell key={index}>
                    <Skeleton width="70%" />
                  </TableCell>
                ),
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                <TableCell>
                  <Skeleton width={30} />
                </TableCell>

                <TableCell>
                  <Skeleton width="60%" />
                </TableCell>

                <TableCell>
                  <Skeleton width="75%" />
                </TableCell>

                <TableCell>
                  <Skeleton
                    variant="rectangular"
                    width={90}
                    height={28}
                    sx={{ borderRadius: 5 }}
                  />
                </TableCell>

                <TableCell>
                  <Skeleton
                    variant="rectangular"
                    width={170}
                    height={36}
                    sx={{ borderRadius: 1 }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      {/* Pagination */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <Skeleton width={110} />
        <Skeleton width={220} />
        <Skeleton width={110} />
      </Stack>
    </Box>
  );
};

export default ETLProcessListskeleton;
